import i18n from './index.js'
export default {//俄文
  translateText: {
    shoppingcart: "тележка для покупок",
    loginorrefisterText: "вход/регистрация",
    logoutText: "выход из логина",
    personcenterText: "личный центр",
    placeholderText: "пожалуйста, выберите",
    loginText: "логин",
    registerText: "pегистрация",
    emailText: "почтовый ящик ",
    pwdText: "пароль",
    forgetpwdText: "забыл пароль?",
    nameText: "имя",
    surnameText: "фамилия",
    mobileText: "телефон",
    setPwdText: "установи пароль",
    countryText: "cтрана",
    company: "kомпания",
    birthday: "День рождения",
    yearText: "годы",
    mouthText: "месяц",
    dayText: "День",
    confirmpwdText: "Подтвердите пароль",
    agreeText1: "я прочитал и согласен",
    agreeText2: "условия использования",
    agreeText3: "и",
    agreeText4: "заявление о конфиденциальности",
    agreeText5: "и согласен с тем, что часть моей личной информации будет обрабатываться за рубежом в соответствии с заявлением о конфиденциальности。",
    emailplaceholder: '"Пожалуйста, введите почтовый ящик',
    subscribetitleText: 'подписка на наши бюллетеня',
    subscribeText: 'подписка',
    shareToText: 'поделитесь с нами',
    searchText: 'Поиск',
    subtractmoneyText: "сокращение до 600",
    magnanimitycouponText: "к вашим услугам большое количество купонов",
    drawText: "получите его немедленно",
    discountText: "чрезмерная скидка",
    purchaseText: "покупайте немедленно",
    composecouponText: "комбинированная покупка",
    manyDiscountsText: "намного больше скидок",
    recommendtitleText: "рекомендуется для вас",
    hotsaleproductyitleText: "продукция для сбыта",
    guessLiketitleText: "Угадай, что тебе нравится",
    NoDataText: "Нет данных ",
    appraiseText: "Оценка",
    certificate: "Ваучер",
    collectText: "Коллекция",
    addCartText: "присоединяйтесь к тележке",
    enterkeywordsText: "введите ключевое слово",
    useNowText: " Немедленное использование ",
    vouchernoText: "номер купона",
    placeholderyearText: " год выбора",
    placeholdermouthText: " месяц выбора",
    placeholderdayText: "день выбора",
    // 优惠券页面
    breadcrumbItemText1: 'Супер',
    breadcrumbItemText2: 'Уровень',
    breadcrumbItemText3: 'Большой',
    breadcrumbItemText4: 'Фу',
    breadcrumbItemText5: 'Ли',
    magnanimitydrawText: 'Большие купоны ждут вас.',
    availablecouponstitleText: 'Доступные ваучеры',
    drawbtnText: 'получайте',
    universalText: 'универсальная игра',
    useText: 'Использование',
    limitText: 'предел',
    fullText: 'полный',
    subtractText: 'минус',
    // 折扣
    discountitemText1: 'Комбинированная покупка ,',
    discountitemText2: 'салют',
    // 组合
    commoditydiscountitemText1: 'Комбинированная покупка ,',
    commoditydiscountitemText2: 'Больше скидок.',
    combinedpriceText: 'комбинированная цена"',
    economizeText: 'Экономьте',
    buynowText: "покупайте немедленно",
    // 产品
    ourproductsText: 'наш продукт',
    productcategoryText: 'категория продуктов',
    recommendtarText: 'рекомендуется',
    newText: 'новый продукт',
    salesvolumetarText: 'продажи',
    pricetarText: 'цена',
    // 博客
    blogmanagementText: "популярный блог",
    latestblogsText: "новый блог",
    relatedrlogsText: "блог, связанный с этим ",
    priceIncreasecommentText: "подчин комментар",
    commentsectionTtxt: "зона комментариев",
    participatingcommentsText: "участвова в комментар",
    // 论坛
    postingText: "постить пост ",
    topicsText: "тема",
    replyText: "ответить",
    viewText: "проверьте",
    lastreplyText: "окончательный ответ",
    publishText: "релиз",
    placeholdertypeText: "пожалуйста, выберите тематическую классификацию",
    placeholdertitleText: "пожалуйста, введите название",
    placeholdercontentsText: "пожалуйста, введите содержимое",
    fromtopicText: "от темы：",
    firstfloor: "Первый этаж ",
    floorText: "здание",
    fromText: "и：",
    postreplyText: "публикуйте ответ",
    // 个人中心 - 我的订单
    myorderText: "мой заказ",
    mycommentsText: "мой комментарий",
    mycollectionText: "Моя коллекция",
    couponText: "Купоны",
    shippingaddressText: "адрес доставки",
    myPostText: "ћ ой пластырь",
    personalinformationText: "личная информация",
    editText: "редактор",
    allordersText: "полный порядок",
    unpaidText: "оставайтесь на оплате ",
    shippedText: "приготовьтесь к отправке",
    receivedText: "Оставайтесь на месте",
    evaluatedText: "оставайтесь на оценке",
    baidText: "внесите платёж",
    completedText: "сделано",
    productinfText: "информация о продуктах",
    unitpricethText: "по одной цене",
    quantitythText: "количество",
    actualpaymentthText: "реальные платежи",
    transactionstatusthText: "статус транзакций",
    operationthText: "Операция",
    ordernumberText: "номер заказа",
    orderdetailsText: "подробности заказа ",
    cancelorderText: "отменить заказ",
    confirmText: "точно",
    cancelText: "отмена",
    deleteordertitle: "уверены, что удалите текущий заказ?",
    successfultradeText: "успешная сделка",
    paymentText: "оплата",
    confirmreceiptText: "подтвердите получение",
    nncommentText: 'никаких комментариев',
    // 个人中心 - 我的评论
    productText: "продукт",
    productdetailText: "подробности оценки",
    replyblogText: "ответ блогу：",
    //个人中心 - 收货地址
    addseliveryaddressText: "новый адрес доставки",
    addaddresstitleText1: "сохранена",
    addaddresstitleText2: "адрес, сохранившийся до сих пор",
    addaddresstitleText3: "адресат записки",
    defaultText: "по умолчанию",
    consigneeText: "получатель",
    addressText: "адрес",
    fulladdressText: "подробный адрес：",
    setdefaultText: "устанавливается по умолчанию ",
    mobilephoneText: "телефон：",
    viewmoreText: "проверьте больше",
    replypostText: "ответить на пост：",
    // 个人中心 - 个人信息
    nameLabel: "Имя",
    sexlabel: "Пол",
    modifyavatarText: "изменение профиля",
    sexmanText: "мужчина",
    sexwomanText: "женщина",
    secrecyText: "Секретность",
    replaceText: "замена",
    saveText: "сохранена",
    oldpasswordText: "оригинальный код",
    newpasswordText: "новый пароль",
    confirmpasswordText: "подтвердить пароль",
    opdpleasolderText: "пожалуйста, введите исходный код",
    newpleasolderText: "пожалуйста, введите новый пароль",
    unboundText: "не связанные ",
    bindingText: "связывание",
    unbindingText: "развязать",
    // 个人中心-个人信息
    regionText: "регион",
    addconsigneleasolderText: "заполн грузополучател им",
    countrypleasolderText: "Пожалуйста, выберите страну",
    provinceleasolderText: "Пожалуйста, выберите страну",
    citypleasolderText: "пожалуйста, выберите город",
    areapleasolderText: "пожалуйста, выберите район",
    fulladdressTextpleasolderText: "пожалуйст, введ подробн",
    addconsignephoneleasolderText: "пожалуйст, заполня грузополучател мобильн телефон номер",
    emailpleasolderText: "Пожалуйста, введите почтовый адрес",
    phoneText: 'Номер телефона',
    uploadimgText: "загрузка изображения",
    updateuserface: "изменение профиля",
    uploadimgtitle1: "поддерживаем изображения в формате JPG, jpeg, PNG ",
    uploadimgtitle2: "рекомендуемые размеры: 200*200 или другие пропорциональные изображения",
    updateemailText: "изменение почтового ящика",
    updatemobileText: "изменить номер телефона ",
    dialogemailtitle: "Адрес почтового ящика",
    dialogmobiletitle: "номер мобильного телефона",
    dialogheadertitle: " Ввод связан с вашим аккаунтом в джинге",
    continueText: "продолжайте",
    verificationinformation: "Проверить информацию",
    verificationinformationTitle1: "буд продолжа, пожалуйст, законч эт провер шаг. У нас есть",
    verificationinformationTitle2: "присла капч. Пожалуйста, введите 。",
    verificationcode: "верификационный код",
    newtitle: "Новый",
    dialognewmobiletitle: "введите новый номер мобильного телефона, который необходимо сопоставить. Нажмите подтвердить замену",
    confirmpbtnText: "подтверждаю",
    titlecpuntryselect: "выберите страну",
    hotcountrytitle: "Горячая страна",
    aboutusText: "о нас",
    // 订单详情
    havequestionsText: "Есть сомнения",
    preferentialText: "скидка",
    enquiryText: "расследование",
    combinationdiscountText: "групповое предложение",
    introduceText: "введение",
    buyermycommentsText: "комментарий покупателя",
    starText: "звезда",
    yourmailboxText: "Ваш почтовый ящик",
    placeholderquestionText: "Ваш почтовый ящик",
    uploadimglimtText: "пожалуйста, загрузите файлы JPG/GIF/PNG. Размер картинки не может быть больше 2мб.",
    submitbtnText: "представлено",
    // 购物车
    selectText: "выбор",
    tipscartsText: "выбранный продукт (без платы за доставку)",
    settlementText: "расчет",
    selectallText: "полный набор",
    amountText: "сумма",
    addtofavoritesText: "присоединяйтесь к коллекционерному зажим",
    havecollectedText: "коллекция собрана",
    tipdelecteproduct: "определить удаление текущих товаров?",
    deleteText: "удалить",
    tipclearcart: "Убедитесь, что вы опустошили тележку?",
    clearcartText: "Освободите тележку от покупок",
    totalText: "совместный план",
    totaltipText: "товары предметов (без платы за доставку):",


    // pieceText:"件",
    // freightText:"运费：",
    // taxationText:"税费：",
    // fullreductionamountText:"满减金额：",
    // amountpayableText:"应付金额：",
    // confirmorderText:"确认订单",
    // paymentsucceededText:"支付成功",
    // receivinginformationText:"收货信息",
    // othershippingaddressText:"其它收货地址",
    // addshippingaddressText:"添加收货地址",
    // selectshippingaddressText:"选择收货地址",
    // selfprimingText:"自提点",
    // typeofshippingText:"运输方式",
    // inquirecostsText:"点击此处咨询运费",
    // confirmproductinformationText:"确认产品信息",
    // settlementinformationText:"结算信息",
    // clipcoupons:"使用优惠券",
    // allitemsText:"全部商品",
    // validtoText:"有效期至",
    // pieceproductTotal:"件产品 总计：",
    // placeorder:"提交订单",
    // consultText:"咨询",
    // consultationText:"请输入咨询内容",
    // sendoutText:"发 送",
    // enterproductname:"输入产品名称",
    // contentText:"内容",
    // filerestrictionsText:"请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
    // withaccountText:"输入与您的 锦格 账户相关联的电子邮箱地址",
    // pagelostText:"很抱歉，你所访问的页面已失联",
    // pagelostText1:"秒后自动跳转到上一页，如没跳转 请点击刷新按钮",
    // pagelostText2:"刷新",
    // pagelostText3:"返回首页",
    // verificationrequiredText:"需要验证",
    // continuestepemailText:"要继续，请完成此验证步骤。 我们已向 电子邮件",
    // sendcodeText:"发送了验证码。 请在下面输入。",
    // resendverificationcodeText:"重新发送验证码",
    // createnewpasswordText:"创建新密码",
    // providepasswordText:"您在每次登录时，都需要提供此密码。",
    // savechangeText:"保存更改并登录",
    // shareToText1: 'follow us  on',
    // productDetailsText:"产品细节",
    // signedforText:"已签收",
    // rejectionText:"拒收",
    // evaluated1Text:"已评价",
    // reviewedText:"待审核",
    // PaidText:"已付款",
    // subtotalText:"小计",
    // waitingforpaymentText:"等待付款",
    // automaticclosingText:"来付款，超时订单自动关闭",
    // patientText:"尊敬的客户，您的订单正在出库，请您耐心等待。",
    // consigneeinformationText:"收货人信息",
    // paymentinformationText:"付款信息",
    // paymentmethodText:"付款方式：",
    // paymenttimeText:"付款时间：",
    // fullnameText:"全名",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_ru.js